export var BLOCK_TYPE = {
  UNSTYLED: 'unstyled',
  UNORDERED_LIST_ITEM: 'unordered-list-item',
  ORDERED_LIST_ITEM: 'ordered-list-item',
  IMAGE: 'image'
};

export var INLINE_STYLE = {
  BOLD: 'BOLD',
  ITALIC: 'ITALIC',
  UNDERLINE: 'UNDERLINE'
};
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/DraftEditor/constants.js
// module id = 989
// module chunks = 0